$('.category-filter__toggle').on('click', function () {
  $('.category-filter__wrap_books').stop().slideToggle();
});